import React from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * HomeRecommendedAction — cyan anchor block on the dark Overview. The
 * whole block is vertically centred so the card fills its row height as
 * one balanced group with no empty band.
 */
export default function HomeRecommendedAction({ title, onAction }) {
  return (
    <div
      className="lg:col-span-3 rounded-2xl bg-[#44b6d2] p-5 shadow-xl flex flex-col justify-center text-[#04222b]"
      data-testid="home-recommended-action"
    >
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#04343f]">Recommended Action</p>
      <p className="text-lg font-extrabold leading-snug mt-2" data-testid="home-recommended-action-title">
        {title}
      </p>
      <button
        type="button"
        onClick={onAction}
        className="mt-4 inline-flex items-center gap-2 self-start rounded-full bg-[#04222b] px-4 py-2 text-sm font-bold text-white transition-transform hover:translate-x-0.5"
        data-testid="home-recommended-action-btn"
      >
        Take action <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
}
